import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_ERROR_TOAST } from '../interceptors/http-error.interceptor';
import { ApiResponse, unwrap } from '../models/api-response.model';
import { CreateTransferApiRequest, CreatedTransferApiItem, TransferApiItem, TransferStatusApi } from './models/transfer-api.model';
import { ProgramQuery } from './models/program-configuration.model';
import { TransferProgress, TransferStatus } from './models/transfer.model';

const TRANSFER_STATUSES: Record<TransferStatusApi, TransferStatus> = {
  PENDIENTE: 'pending',
  PROCESANDO: 'processing',
  COMPLETADO: 'completed',
  ERROR: 'error',
};

function toTransferStatus(status: TransferStatusApi): TransferStatus {
  const mapped = TRANSFER_STATUSES[status];
  if (mapped) return mapped;

  console.warn(`Unknown transfer status "${status}"; treated as processing.`);
  return 'processing';
}

@Injectable({ providedIn: 'root' })
export class TransferService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}incentivos`;

  createTransfer(query: ProgramQuery): Observable<string> {
    const body: CreateTransferApiRequest = {
      idPais: query.countryId,
      idPrograma: query.programId,
      idIncentivo: query.incentiveId,
    };

    return this.http
      .post<ApiResponse<CreatedTransferApiItem>>(`${this.apiUrl}/transferencia`, body)
      .pipe(map((response) => unwrap(response).transferencia));
  }

  getTransfer(id: string): Observable<TransferProgress> {
    return this.http
      .get<ApiResponse<TransferApiItem>>(`${this.apiUrl}/${encodeURIComponent(id)}`, {
        context: new HttpContext().set(SKIP_ERROR_TOAST, true),
      })
      .pipe(
        map((response) => {
          const item = unwrap(response);
          return {
            id: item.idTransferencia,
            status: toTransferStatus(item.estado),
            total: item.totalRegistros,
            processed: item.registrosProcesados,
            errorMessage: item.mensajeError,
          };
        }),
      );
  }
}
